import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import "./Parallax.css";
import '../styles.css'

const Page = ({ bgColor, image, title, text }) => {
  const textRef = useRef();
  const imageRef = useRef();

  const isTextInView = useInView(textRef, { margin: "-20% 0px -20% 0px", amount: 0.5 });
  const isImageInView = useInView(imageRef, { margin: "-20% 0px -20% 0px", amount: 0.5 });

  return (
    <section className="sectionContainer" style={{ backgroundColor: bgColor }}>
      <motion.div
        ref={textRef}
        className="textSection"
        initial={{ opacity: 0, y: 50 }}
        animate={isTextInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.8 }}
      >
        <h1>{title}</h1>
        <br />
        <h5>{text}</h5>
      </motion.div>

      <motion.div
        ref={imageRef}
        className="imageDiagonal"
        style={{ backgroundImage: `url(${image})` }}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={isImageInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      />
    </section>
  );
};

export default Page;
